import { cn } from '@core/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithoutRef } from 'react';

import ApplyBadge from './svg/apply-badge.svg';
import BuildingBadge from './svg/building-badge.svg';
import StarBadge from './svg/star-badge.svg';

const badgeVariants = cva([
  'rounded-xsmall',
  'px-6 py-2',
  'font-600 typo-caption1',
  'inline-flex items-center gap-4',
  'bg-Gray-200 text-Gray-700',
]);

interface BadgeProps
  extends ComponentPropsWithoutRef<'span'>,
    VariantProps<typeof badgeVariants> {
  icon?: 'building' | 'star' | 'apply';
}

const Badge = ({ className, icon, children, ...props }: BadgeProps) => {
  const Icon =
    icon === 'building' ? BuildingBadge : icon === 'star' ? StarBadge : null;

  if (icon === 'apply') {
    return <ApplyBadge />;
  }

  return (
    <span className={cn(badgeVariants(), className)} {...props}>
      {Icon ? <Icon /> : null}
      {children}
    </span>
  );
};

export { Badge, type BadgeProps };
